import Api from "@/helpers/api";
import moment from "moment";
import { loading, closeLoding, notify } from "@/helpers/$vs";

export default {
  data() {
    return {
      listUsers: [],
      keyOneUser: "",
      listCompanies: [],
      idCompany: "",
      tokenSuccess: ""
    };
  },
  methods: {
    /**
     * Obtiene una lista de los usuarios por compañía
     * @param {string} idCompany
     * @param {Boolean} load
     */
    async getUsers(idCompany, load = true) {
      try {
        if (load) loading();
        const data = {
          companyID: idCompany,
          roleName: "ADMIN"
        };
        const result = await Api.post("/users/companies", data);
        this.listUsers = result.data;
        await this.getCompanies(idCompany);
      } catch (error) {
        console.log("Error tokens: getUsers ", error);
        if (error.status === 400) this.listUsers = [];
      } finally {
        closeLoding();
      }
    },

    /**
     * Obtiene información de una compañía
     * @param {string} companyID
     */
    async getCompanies(companyID) {
      try {
        const result = await Api.get("/companies/" + companyID);
        this.disabledDates.from = moment(result.data.expireAccount).add(1, "days").toDate();
      } catch (error) {
        console.log("Error tokens: getUsers ", error);
      }
    },

    /**
     * Obtiene una lista con la información de todas las compañías
     */
    async getAllCompanies() {
      try {
        const result = await Api.get("/companies");
        this.listCompanies = result.data.filter(company => company.status === "Active");
      } catch (error) {
        console.log("Error tokens: getUsers ", error);
      }
    },

    /**
     * Crea un token para una compalía.
     * @returns  { notify }
     */
    async createToken() {
      if (this.keyOneUser.trim().length === 0) return notify(this.$t(`ACCESTOKENS.user`), this.$t(`ACCESTOKENS.selectedUser`), "warning");

      try {
        loading();
        const data = {
          companyID: this.idCompany,
          userID: this.keyOneUser,
          dateToExpire: moment(this.expireAccount).format("YYYY-MM-DD")
        };
        const result = await Api.post("/auth/sessions", data);
        this.tokenSuccess = result.data.accessToken;
      } catch (error) {
        console.log("Error: createToken", error);
      } finally {
        closeLoding();
      }
    },
    /**
     * Funcionalidad para seleccionar un usuario.
     * @param {string} event - id ó key del usuario seleccinado
     */
    selectedUser(event) {
      this.tokenSuccess = "";
      this.keyOneUser = event;
    },
    /**
     * Resetea las variables
     */
    clear() {
      this.tokenSuccess = "";
      this.userID = "";
      this.keyOneUser = "";
    }
  },
  computed: {
    /**
     *
     * @returns {Array} - Devuelve una lista de usuarios activos y de rol ADMIN según el criterio de busqueda {string}
     */
    _filterUsers() {
      return this.listUsers
        .filter(user => user.status === "Active" && user.roleName === "ADMIN")
        .filter(user => {
          if (this.searchUser.trim().length > 0) {
            return user.name.toLowerCase().includes(this.searchUser.toLowerCase());
          }
          return true;
        });
    },
    /**
     *
     * @returns {Array<Object>} - Devuelve un array de objetos con proieddes relevantes del usuario
     */
    _MapUsers() {
      return this._filterUsers.map(({ key, name, lastname, cellPhone, email, created_at, roleName, companyName }) => ({
        key,
        name: `${name} ${lastname}`,
        phone: cellPhone,
        email,
        created: created_at,
        roleName
      }));
    },
    /**
     *
     * @returns {Array} - Devueolve un array que contiene un objeto de la data de un usuario.
     */
    _getOneUser() {
      const data = {
        name: "",
        lastname: "",
        address: "",
        cellPhone: "",
        email: "",
        roleName: "",
        companyID: "",
        companyName: ""
      };
      return this._filterUsers.filter(user => user.key === this.keyOneUser)[0] || data;
    },
    /**
     *
     * @returns {boolean} - Verifica si el usuario de tipo GOTU
     */
    isGotu() {
      return this.$store.state.user.roleName === "GOTU";
    },
    /**
     *
     * @returns {boolean} - habilita o desabilita el botón crear token
     */
    btn_disbled() {
      return this.keyOneUser.trim().length === 0 || this.idCompany.trim().length === 0;
    },
    /**
     *
     * @returns {boolean} - Muestra u oculta el botón crear token.
     */
    accessTokenCreated() {
      return this.tokenSuccess.trim().length === 0;
    }
  }
};
